import * as React from "react";

export class EmptyMsg extends React.Component<{ label: string }, {}> {
    render() {
        return (
            <p className="rj-yourbet__empty-msg">{this.props.label}</p>
        );
    }
}